<template>
<div id="Roadmap">
    <img class="roadmap" src="../../assets/roadmap.png" alt="">
</div>
</template>

<script>
export default {
    name: "Roadmap"
}
</script>

<style scoped>
.roadmap
{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/HomeComp/Roadmap.vue